define('Eureka.MaxaPartPicker.MaxaPartPicker.Form.View', [
    'Backbone',
    'SCFormView',
    'Utils',
    'eureka_maxapartpicker_itemview.tpl'
], function (
    Backbone,
    SCFormViewModule,
    Utils,
    eureka_maxapartpicker_itemview_tpl
) {
    'use strict';

    var SCFormView = SCFormViewModule.SCFormView;

    function MaxaPartPickerFormView (options) {
        SCFormView.call(this, options.model);
        //console.log("In Here")
        this.formModel.on('sync', function () {
            Backbone.history.navigate('preferences', {trigger: true});
        });

        this.template = eureka_maxapartpicker_itemview_tpl;
    }

    MaxaPartPickerFormView.prototype = Object.create(SCFormView.prototype)
    MaxaPartPickerFormView.prototype.constructor = MaxaPartPickerFormView;

    MaxaPartPickerFormView.prototype.getEvents = function () {
        return {
            'submit form': 'saveForm'
        }
    }

    MaxaPartPickerFormView.prototype.saveForm = function (e) {
        e.preventDefault();

        var promise = SCFormView.prototype.saveForm.call(this, e);

        return promise
    }

    MaxaPartPickerFormView.prototype.getFormValues = function (form) {
        var formValues = form.serializeObject();

        return {
            type: formValues.type,
            value: formValues.value
        }
    }

    MaxaPartPickerFormView.prototype.getContext = function () {
        //console.log("this.formModel", this.formModel)
        return {
            message: this.formModel.get('message')
        }
    }

    return MaxaPartPickerFormView
})
